// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax

import React, { Component } from 'react';

import InfoPanel from '../components/Livemap/InfoPanel.js';
import VehicleAccordion from '../components/Livemap/VehicleAccordion.js';
import MapDrawer from '../components/Drawers/MapDrawer.js';
import KPICard from '../components/Dashboard/KPIMapCard.js';
import ControlPanel from '../components/Livemap/ControlPanel.js';

import dayjs from 'dayjs';

import optc from '../optc.json'
import Map, { Source, Layer } from 'react-map-gl';

import mapboxgl from 'mapbox-gl';
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

import ReactLoading from 'react-loading';

import { withTranslation } from 'react-i18next';

import {
  getLiveData, leave,
  getTraces, getStops,
  getAgencies, getGroups,
  getUserAgency, getUserGroup
} from '../API.js'

class Livemap extends Component {

  //INITIALIZE STATE
  state = {
    agencies: [],
    zoomgroup: 'stm',
    vehiclePlaceholder: [
      {
        operateur: 'opérateur',
        groupe: 'opérateur',
        vehlen: 'véhicules en ligne',
        timestr: 'heure',
        planned: 'véhicules planifiés',
      }
    ],
    viewState: {
      latitude: 45.556827,
      longitude: -73.662362,
      zoom: 9
    },
    firstZoom: 0,
    emptyGeoJSON: { "type": "FeatureCollection", "features": [] },
    open: false,
    mapStops: { "type": "FeatureCollection", "features": [] },
    mapTrace: { "type": "FeatureCollection", "features": [] },
    stopsColor: "#000000",
    switch: 0,
    timeFormat: dayjs(new Date()).format('YYYY-MM-DD')
  };

  mapRef = React.createRef();

  controller = new AbortController();

  componentDidMount = async () => {

    const userAgency = await getUserAgency();
    const admin = userAgency == 'admin' ? 1 : 0;
    const userGroup = await getUserGroup();

    window.mobileCheck = function () {
      let check = false;
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    };

    const isMobile = window.mobileCheck();

    //CONNECT TO SOCKET TO GET REALTIME DATA
    if (this.state.switch == 0) {

      const getData = getLiveData((err, positions) => {

        let groupList = positions ? [...new Set(positions.newData.map(i => i.groupe))] : '';

        let vehicleData = positions ? positions.newData.filter((f) => { return f.groupe == f.operateur }) : '';

        // Separer les vehicules des sociétés groupées (ex : exo) des sociétés uniques
        let groupData = positions ? positions.newData.filter((f) => { return f.groupe != f.operateur }) : '';
        let groups = [...new Set(groupData.map(i => i.groupe))];

        groups.forEach((e) => {

          let vehFeat = { type: 'FeatureCollection', features: [] };
          let veh = positions.newData.filter((f) => { return f.groupe == e });

          let VehLen = 0;
          let Planned = 0;

          veh.forEach((f) => {
            VehLen += f.vehlen;
            Planned += f.planned;
            f.data.features.forEach(((g, i) => {
              vehFeat.features.push(g);
            }))
          })

          vehicleData.push({
            operateur: e,
            groupe: e,
            planned: Planned,
            rid: veh[0].rid,
            timestr: veh[0].timestr,
            vehlen: VehLen,
            data: vehFeat
          });

        })

        //GET PLANNED AND REAL VEHICLE COUNTS FOR THE CURRENT TIMESTAMP
        let vehTotal = vehicleData ? vehicleData[0].vehlen >= 0 ? admin == 0 ?
          vehicleData.filter((f) => { return f.groupe == userGroup }).reduce((acc, obj) => {
            return (acc + obj.vehlen)
          }, 0) : vehicleData.reduce((acc, obj) => {
            return (acc + obj.vehlen)
          }, 0) : t('data.loading') : t('data.loading')

        let plannedVehTotal = vehicleData ? vehicleData[0].planned >= 0 ? admin == 0 ?
          vehicleData.filter((f) => { return f.groupe == userGroup }).reduce((acc, obj) => {
            return (acc + obj.planned)
          }, 0) : vehicleData.reduce((acc, obj) => {
            return (acc + obj.planned)
          }, 0) : t('data.loading') : t('data.loading')


        this.setState({
          vehicleData,
          groupList: userAgency == 'admin' ? groupList : [userGroup],
          vehTotal,
          plannedVehTotal,
          switch: 1,
          admin,
          userAgency: userAgency == 'admin' ? 'stm' : userAgency,
          isMobile,
          userGroup
        })

      })
    }

    let layerGroups = [];

    const agencies = getAgencies().then((result) => {
      layerGroups = [...new Set(result.map((a) => { return "position-vehicules-" + a.groupe }))]
    });


    //List all agencies if admin only
    if (admin == 0) {
      this.setState({
        groups: [{ groupe: userGroup }],
        agencies,
        layerGroups
      })
    } else {
      const groups = getGroups().then((result) => {
        this.setState({
          groups: result,
          agencies,
          layerGroups
        });
      });
    }

  }

  //DELETE MAP AND CANCEL SUBSCRIPTION TO SOCKET ON PAGE CHANGE
  componentWillUnmount = () => {
    this.mapRef.current = null;
    this.controller.abort();
    leave();
  }


  handleOnLoad = () => {
    this.setState({ mapIsLoaded: true });
  }


  //DATA UPDATE PROCESS WHEN NEW DATA IS RECEIVED FROM SOCKET
  componentDidUpdate = (prevProps, prevState) => {

    const { vehicleData, groupList, mapIsLoaded
    } = this.state;

    if (!mapIsLoaded) {
      return;
    }

    let map = this.mapRef.current;

    // Init clicked features
    map.getSource("stops").setData(this.state.mapStops);
    map.getSource("trace").setData(this.state.mapTrace);

    // Refresh map points
    if (vehicleData !== prevState.vehicleData && this.state.switch == 1 && this.state.firstZoom == 0) {

      let latlong = optc.optc.find((e) => e.operateur == this.state.userAgency[0]).latlong
      this.state.admin == 0 ?
        this.zoomToLocation(latlong, this.state.userAgency) :
        '';

    }

    if (vehicleData !== prevState.vehicleData && this.state.switch == 1) {

      let time = new Date();
      let timeFormat = dayjs(time).format('HH:mm:ss');

      groupList.forEach((a) => {

        //THIS LINE WILL REFRESH THE VEHICLES DATA IN THE MAP LAYER
        map.getSource("vehicules" + a.toUpperCase()).setData(vehicleData.find(f => f.groupe === a).data);

        let vehRoutes = vehicleData.find(f => f.groupe === a).data.features.map((e) => {
          return e.properties.route_id
        });

        let uniqueRoutes = [...new Set(vehRoutes)];

        let data = vehicleData;

        for (let d = 0; d < data.length; d++) {
          if (data[d].groupe === a) {
            data[d].routes = uniqueRoutes;
            break;
          }
        };

        this.setState({
          vehicleData: data
        });
      });


      //Custom KPIs
      let filtered = vehicleData.filter((f) => { return f.groupe == this.state.userGroup })

      //Routes
      let activeRoutes = 0;
      this.state.admin == 0 ?
        filtered.forEach((e) => {
          activeRoutes += e.routes.length
        }) : vehicleData.forEach((e) => {
          activeRoutes += e.routes.length;
        })

      //Speed
      let speed = 0;
      this.state.admin == 0 ?
        filtered.forEach((e) => {
          let avgSpeed = e.data.features.reduce(
            (accumulator, currentValue) => accumulator + parseFloat(currentValue.properties.speed),
            0
          ) / e.data.features.length;
          speed += avgSpeed;
        }) :
        vehicleData.forEach((e) => {
          let avgSpeed = e.data.features.reduce(
            (accumulator, currentValue) => accumulator + parseFloat(currentValue.properties.speed),
            0
          ) / e.data.features.length;
          speed += avgSpeed;
        })

      let avgS = this.state.admin == 0 ?
        (speed / filtered.length).toFixed(1) :
        (speed / vehicleData.length).toFixed(1);

      //Occupancy
      let occupancy = 0;
      this.state.admin == 0 ?
        filtered.forEach((e) => {
          let avgOccupancy = e.data.features.reduce(
            (accumulator, currentValue) => currentValue.properties.occupancy_status ? accumulator + parseInt(currentValue.properties.occupancy_status) : accumulator + 0,
            0
          ) / e.data.features.length;
          occupancy += avgOccupancy;
        }) :
        vehicleData.forEach((e) => {
          let avgOccupancy = e.data.features.reduce(
            (accumulator, currentValue) => currentValue.properties.occupancy_status ? accumulator + parseInt(currentValue.properties.occupancy_status) : accumulator + 0,
            0
          ) / e.data.features.length;
          occupancy += avgOccupancy;
        })
      let avgO = this.state.admin == 0 ?
        (occupancy / filtered.length).toFixed(1) :
        (occupancy / vehicleData.length).toFixed(1);


      //OTP based on delay at stops
      let onTime = 0;
      let early=0;
      let late=0;
      let total = filtered[0].data.features.length;
      filtered[0].data.features.forEach((e)=>{
        if (e.properties.delay<-60) {
          early+=1;
        } else if (e.properties.delay>180) {
          late+=1;
        } else (
          onTime+=1
        )
      })

      //Refresh clicked vehicle properties
      let refreshList = this.state.clickedVehicle ? vehicleData.filter(f => f.groupe == this.state.clickedAgency) : '';
      let refreshVehicle = refreshList !== '' ? refreshList[0].data.features.find(f => parseInt(f.id) == this.state.clickedVehicle) : '';
      this.setState({
        clickedFeature: refreshVehicle,
        timeFormat,
        avgSpeed: avgS,
        activeRoutes,
        avgOccupancy: avgO,
        firstZoom: 1,
        onTimePct:onTime/total
      })

    };
  }


  _onHover = event => {

    const { features, point: { x, y } } = event;

    const { groups } = this.state;

    const hoveredFeatures = [];

    groups.forEach((a) => {
      let hoveredFeature = features && features.find(f => f.properties.group === a.groupe);
      hoveredFeatures.push({
        group: a.groupe,
        hoveredFeature
      })
    })

    this.setState({
      hoveredFeatures,
      x,
      y
    });

  };

  _onMouseOut = event => {

    const hoveredFeatures = [];

    this.setState({
      hoveredFeatures
    });

  };


  zoomToLocation = (location, groupe, vehicle) => {
    this.mapRef.current?.flyTo({ center: [location[1], location[0]], duration: 2000, zoom: vehicle ? 14 : 9 });
    this.setState({ zoomgroup: groupe })
  }

  highlightListClick = (feature, groupe) => {
    let map = this.mapRef.current;

    if (this.state.clickedVehicle) {
      map.removeFeatureState({
        source: "vehicules" + this.state.clickedAgency.toUpperCase(),
        id: this.state.clickedVehicle
      });
    }

    map.setFeatureState({
      source: "vehicules" + groupe.toUpperCase(),
      id: feature.id,
    }, {
      clicked: true
    });

    this.setState({
      clickedVehicle: feature.id,
      clickedAgency: groupe,
      clickedFeature: feature,
      mapStops: this.state.emptyGeoJSON,
      mapTrace: this.state.emptyGeoJSON
    })

  }

  _onClick = event => {

    const { mapIsLoaded } = this.state;

    const { features, point: { x, y } } = event;

    let map = this.mapRef.current;

    if (features.length > 0) {

      let agency = features[0] ? features[0].properties.agency : '';
      let group = features[0] ? features[0].properties.group : '';
      let api = agency !== '' ? optc.optc.find((e) => e.operateur == agency).api : '';
      let color = agency !== '' ? optc.optc.find((e) => e.operateur == agency).color : '';
      let trip_id = api == 'gtfsr' ? features[0].properties.trip_id ? features[0].properties.trip_id : '' : '';
      let route_id = agency !== '' ? features[0].properties.route_id ? features[0].properties.route_id : '' : '';

      this.highlightListClick(features[0], group);

      if (trip_id !== '') {
        this.setState({ stopsColor: color });

        let changePoints = api == 'gtfsr' ? getStops(agency, trip_id).then((result) => {
          this.setState({
            mapStops: result
          })
          map.getSource("stops").setData(this.state.mapStops)
        }) : '';

        let changeTraces = api == 'gtfsr' ? getTraces(agency, trip_id, route_id).then((result) => {
          this.setState({
            mapTrace: result
          })
          map.getSource("trace").setData(this.state.mapTrace)
        }) : '';
      }

      this.setState({
        clickedVehicle: features[0].id,
        clickedAgency: group
      })

    } else {

      if (this.state.clickedVehicle) {
        map.removeFeatureState({
          source: "vehicules" + this.state.clickedAgency.toUpperCase(),
          id: this.state.clickedVehicle
        });
      }

      this.setState({
        mapStops: this.state.emptyGeoJSON,
        mapTrace: this.state.emptyGeoJSON,
        clickedVehicle: '',
        clickedAgency: '',
        clickedFeature: ''
      });

    }

  };


  _renderTooltip() {

    const {
      hoveredFeatures, groups,
      x, y } = this.state;

    //SHOW TOOLTIPS ON HOVER

    //GET HOVERED FEATURE INFO
    let showFeats = [];
    let test = hoveredFeatures ?
      groups.forEach((a) => {
        let feat = hoveredFeatures.find(f => f.group === a.groupe) ?
          hoveredFeatures.find(f => f.group === a.groupe).hoveredFeature ?
            hoveredFeatures.find(f => f.group === a.groupe).hoveredFeature : '' : '';
        showFeats.push(feat);
      }) : ''


    let clean = showFeats.filter(element => {
      return element !== '';
    });

    //SHOW FEATURE INFO

    if (this.state.isMobile == false) {

      let { t } = this.props;
      
      return (
        clean ? clean[0] ?
          (
            <div className="mapToolTip" style={{ left: x, top: y }}>
              <div>{t('map.operator')} {optc.optc.find((f) => clean[0].properties.agency == f.operateur).nom}</div>
              <div>{t('map.infopanel.vehicle')} {clean[0].properties.vehicle_id}</div>
              <div>{t('map.infopanel.route')} {clean[0].properties.route_id}</div>
              <div>{t('map.infopanel.occupancy')} {clean[0].properties.occupancy_status ? clean[0].properties.occupancy_status : t('map.na')}</div>
              <div>{t('map.infopanel.delay')} {clean[0].properties.delay ? parseFloat(clean[0].properties.delay/60).toFixed(0) + " min": t('map.na')} </div>
              <div>{t('map.infopanel.updated')} {clean[0].properties.last_connection ? dayjs.unix(clean[0].properties.last_connection).format('HH:mm:ss') : t('map.na')} </div>
              <div>{t('map.infopanel.bearing')} {clean[0].properties.bearing ? <i className="fa fa-arrow-up"
                style={{ transform: `rotate(${clean[0].properties.bearing}deg)` }} aria-hidden="true"></i> : t('map.na')}
              </div>
            </div>
          ) : '' : ''
      )
    }
  }


  //Drawer functions
  handleToggle = () => this.setState({ open: !this.state.open });


  render() {

    const { t } = this.props;

    const { groups, vehicleData, userAgency } = this.state;

    //get otp limits
    const lowerLimit = userAgency ? (optc.optc.find((e) => e.operateur == userAgency).ontimelimits[0]*60)-29 : 1;
    const higherLimit = userAgency ? (optc.optc.find((e) => e.operateur == userAgency).ontimelimits[1]*60)+29 : 1;

    return groups ? (

      <React.Fragment>

        <div className="row justify-content-center ps-1 pe-1">
          <h1 id="page-title" className="display-5">{t('map.title')}</h1>
        </div>

        <div className="container-fluid">

          {/* <div className="row no-gutters align-items-center"> */}
          <div className="row row-cols-1 row-cols-md-3 g-4 pb-3">
            <KPICard
              kpi={this.state.avgOccupancy && this.state.switch == 1 ? this.state.vehicleData[0].timestr : t('map.loading')}
              desc={t("map.updated")}
            />
            <KPICard
              kpi={this.state.avgOccupancy ? this.state.vehTotal + " / " + this.state.plannedVehTotal: t('map.loading')}
              desc={t("map.online") + " / " + t("map.planned")}
            />
            <KPICard
              kpi={this.state.avgOccupancy ? parseFloat(this.state.onTimePct*100).toFixed(0) + "%": t('map.loading')}
              desc={t("map.ontime")}
            />
            <KPICard
              kpi={this.state.avgOccupancy ? this.state.activeRoutes : t('map.loading')}
              desc={t("map.routes")}
            />
            <KPICard
              kpi={this.state.avgOccupancy ? this.state.avgSpeed + ' km/h' : t('map.loading')}
              desc={t("map.avgsp")}
            />
            <KPICard
              kpi={this.state.avgOccupancy ? this.state.avgOccupancy : t('map.loading')}
              desc={t("map.avgld")}
            />
          </div>

          <MapDrawer
            toggle={this.handleToggle}
            open={this.state.open}
          >
            <VehicleAccordion
              opData={this.state.vehicleData ? this.state.vehicleData : this.state.vehiclePlaceholder}
              properties={optc.optc}
              apiPlaceholder={t('map.loading')}
              routesPlaceholder={'routes'}
              zoomToLocation={this.zoomToLocation}
              highlightListClick={this.highlightListClick}
              zoomgroup={this.state.zoomgroup}
              userAgency={this.state.userAgency}
              admin={this.state.admin}
              group={this.state.userGroup}
            />
          </MapDrawer>


          <div className="row no-gutters overflow-hidden">
            <div className="col-lg-12 col-sm-12">
              <Map
                initialViewState={this.state.viewState}
                style={{ width: '100%', height: '75vh' }}
                ref={this.mapRef}
                onLoad={() => { this.handleOnLoad() }}
                mapStyle="mapbox://styles/wdoucetk/cjun8whio1ha21fmzxt8knp7k"
                mapboxAccessToken={process.env.REACT_APP_MAPBOX_KEY}
                onMouseEnter={this._onHover}
                onMouseLeave={this._onMouseOut}
                onClick={this._onClick}
                attributionControl={false}
                interactiveLayerIds={
                  groups.map((g) => { return "position-vehicules-" + g.groupe })
                    .concat("stop-points", "trip-trace")
                }
              >
                {this._renderTooltip()}
                {[//trace
                  <Source
                    key={"trace"}
                    id={"trace"}
                    type="geojson" data={this.state.emptyGeoJSON}
                  >
                    <Layer {...{
                      "id": "trip-trace",
                      "type": "line",
                      "source": "trace",
                      "layout": {
                        "line-join": "round",
                        "line-cap": "round",
                        "visibility": "visible"
                      },
                      "paint": {
                        "line-width": 2,
                        "line-color": this.state.stopsColor
                      }
                    }} />
                  </Source>]
                  .concat(
                    //stops
                    <Source
                      key={"stops"}
                      id={"stops"}
                      type="geojson" data={this.state.emptyGeoJSON}
                    >
                      <Layer {...{
                        "id": "stop-points",
                        "type": "circle",
                        "source": "stops",
                        "paint": {
                          "circle-radius": 3,
                          "circle-color": "white",
                          "circle-stroke-width": 1,
                          "circle-stroke-color": this.state.stopsColor,
                        }
                      }} />
                    </Source>,
                    //vehicle positions
                    groups.map(g => (
                      <Source
                        key={g.groupe + '-positions'}
                        id={"vehicules" + (g.groupe.toUpperCase())}
                        type="geojson" data={this.state.emptyGeoJSON}
                      >

                        {/* <Layer {...{
                          "id": "base-symbol-" + g.groupe,
                          "type": "symbol",
                          "source": "vehicules" + g.groupe.toUpperCase(),
                          "layout": {
                            'text-field': String.fromCharCode("0xF0d8"), // Unicode for the arrow
                            'text-font': ['Font Awesome 5 Free Solid'],
                            'text-size': 20,
                            'text-rotate': ['get', 'bearing'], // Rotate the arrow based on bearing
                            'text-allow-overlap': true,
                            'text-ignore-placement': true,
                            'text-offset': [
                              ['*', ['cos', ['/', ['*', ['get', 'bearing'], Math.PI], 180]], 10], // Horizontal offset
                              ['*', ['sin', ['/', ['*', ['get', 'bearing'], Math.PI], 180]], 10]  // Vertical offset
                            ],
                          },
                          "paint": {
                            "text-color": '#000000', // Arrow color
                          }
                        }} /> */}
                        <Layer {...{
                          "id": "position-vehicules-" + g.groupe,
                          "type": "symbol",
                          "source": "vehicules" + g.groupe.toUpperCase(),
                          "layout": {
                            'text-field': String.fromCharCode("0xF207"),
                            'text-font': ['Font Awesome 5 Free Solid'],
                            'text-size': 12
                          },
                          "paint": {
                            "text-color": [
                              'case',
                              ['boolean', ['feature-state', 'clicked'], false],
                              '#4d0077', // if selected true, paint in purple
                              [
                                'case',
                                ['all', ['>=', ['get', 'delay'], -2000], ['<', ['get', 'delay'], lowerLimit]], '#ff0000', // red for delay between -1000 and -60
                                ['all', ['>=', ['get', 'delay'], higherLimit], ['<=', ['get', 'delay'], 2000]], '#FFC300', // yellow for delay between 180 and 1000
                                ['all', ['>=', ['get', 'delay'], lowerLimit], ['<=', ['get', 'delay'], higherLimit]], ' #29c521', // green for delay between -60 and 180
                                optc.optc.find((e) => e.groupe == g.groupe).color // default color if none of the conditions match
                              ]
                            ],
                            "text-halo-color": [
                              'case',
                              ['boolean', ['feature-state', 'clicked'], false],
                              '#ffa600',
                              '#fff'
                            ],
                            "text-halo-width": 2
                          }
                        }
                        } />
                      </Source>
                    )
                    )
                  )}
                <ControlPanel
                  handleToggle={this.handleToggle}
                />
                <InfoPanel
                  vehicle={this.state.clickedFeature}
                  agency={this.state.clickedFeature ? optc.optc.find((f) => this.state.clickedFeature.properties.agency == f.operateur).nom : ''}
                />
                {this.state.avgOccupancy ? '' :
                  <div className="mapspinner">
                    <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
                  </div>
                }
              </Map>
            </div>

          </div>
        </div>
      </React.Fragment>
    ) :
      <div className="d-flex justify-content-center">
        <div className="row">
          <div className="col-sm">
            <h1 className="display-5">{t('data.loading')}</h1>
            <div className="d-flex justify-content-center">
              <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
            </div>
          </div>
        </div>
      </div>

  }
}

export default withTranslation('common')(Livemap);
//export default Livemap;


//mapbox://styles/wdoucetk/cjun8whio1ha21fmzxt8knp7k light
//mapbox://styles/wdoucetk/cjuc6i3960ggz1flfzzn3upav navigation